import AssignmentRatesDefaultModal from "@app/components/modals/assignments/rates/assignment-rates-default-modal.tsx";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { assignmentExpenseRateDetailsTableDefinition } from "@app/table-definitions/assignment-expense-rate-details.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentRatesDefaultsForm({ id }: Props) {
    const [defaultId, setDetailId] = useState<number>();
    const [detailDefaultsOpen, setDetailDefaultsOpen] = useState(false);

    const { assignmentDetailGrid, deleteAssignmentDetail } = useAssignmentData({
        id: id,
    });

    return (
        <>
            <AssignmentRatesDefaultModal
                open={detailDefaultsOpen}
                onClose={() => {
                    setDetailDefaultsOpen(false);
                    setDetailId(undefined);
                }}
                id={defaultId}
                assignmentId={id}
            />
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Detail Defaults"}
                actions={
                    <Button variant={"contained"} onClick={() => setDetailDefaultsOpen(true)}>
                        Add New
                    </Button>
                }
                columns={assignmentExpenseRateDetailsTableDefinition({
                    onEdit: (id) => {
                        setDetailDefaultsOpen(true);
                        setDetailId(id);
                    },
                    onDelete: (id) => deleteAssignmentDetail.mutate(id),
                    rowCount: assignmentDetailGrid.data?.length ?? 0,
                })}
                data={assignmentDetailGrid.data ?? []}
                queryHook={assignmentDetailGrid}
            />
        </>
    );
}
